module.exports = __webpack_public_path__ + "static/media/terms-of-use.40f4c835.txt";